module.exports = __webpack_public_path__ + "static/gif-8586cd73152f0754ac0621d030194ff4.gif";